// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1TyyE","box":"WorkspacesBox_box__dKy90","node":"WorkspacesBox_node__3UxRD"};